var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Twitter"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.49,30H5.5A3.35,3.35,0,0,1,3,29a3.35,3.35,0,0,1-1-2.48V5.5A3.35,3.35,0,0,1,3,3,3.35,3.35,0,0,1,5.5,2h21A3.35,3.35,0,0,1,29,3,3.35,3.35,0,0,1,30,5.5v21A3.52,3.52,0,0,1,26.49,30ZM12.64,23.39a10.45,10.45,0,0,0,6.89-2.52,11.07,11.07,0,0,0,3.08-4.57,10.45,10.45,0,0,0,.62-3.37v-.64a7.78,7.78,0,0,0,1-.9,8.3,8.3,0,0,0,.83-1h0a6.22,6.22,0,0,1-2.08.58v0a4.21,4.21,0,0,0,.78-.6,4.61,4.61,0,0,0,.82-1.43,6.54,6.54,0,0,1-1.53.69,5.29,5.29,0,0,1-.85.21,3.87,3.87,0,0,0-2.7-1.16,3.72,3.72,0,0,0-2.62,1.06,3.61,3.61,0,0,0-1.13,2.67,4,4,0,0,0,.1.85,12.68,12.68,0,0,1-1.63-.2,12.54,12.54,0,0,1-3.59-1.49A11.24,11.24,0,0,1,8.16,9.29a3.83,3.83,0,0,0,.4,4.27,2.74,2.74,0,0,0,.73.67v0a3.73,3.73,0,0,1-1.65-.45,3.81,3.81,0,0,0,1.13,2.72,3.72,3.72,0,0,0,1.3.8,2.66,2.66,0,0,0,.52.17,1.34,1.34,0,0,1-.42.1H9.6a4.12,4.12,0,0,1-.66-.05,3.74,3.74,0,0,0,1.53,2,3.7,3.7,0,0,0,1.94.58,7.07,7.07,0,0,1-1.05.72,7.51,7.51,0,0,1-3.43.88,9.46,9.46,0,0,1-1,0A10.38,10.38,0,0,0,12.64,23.39Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.60df14d5afe616c0a21137d14956d34e.svg";
export { ForwardRef as ReactComponent };